import { apiRequestWrapper } from '~/helpers/apiRequestWrapper'
import type { Media } from '~/types/Media'

type ResponseMedia = Media['attributes'] & { id: Media['id'] }

export async function uploadFiles(images: Blob | Blob[]): Promise<ResponseMedia[]> {
  const token = useStrapiToken()

  const formData = new FormData()

  if (Array.isArray(images)) {
    images.forEach((image) => {
      formData.append('files', image)
    })
  }
  else {
    formData.append('files', images)
  }

  return apiRequestWrapper(`/upload`, {}, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token.value}`,
    },
    body: formData,
  })
}

/**
 * Edits the hero section image of an issue.
 *
 * @param id - The ID of the issue.
 * @param imageId - The ID of the image to set as the hero image. Can be a number, string, or null. If null, the hero image will be removed.
 * @returns A promise that resolves to the result of the API request.
 */
export async function editHeroImage(id: number, imageId: number | string | null) {
  const token = useStrapiToken()

  const image = imageId === null ? null : { id: imageId }

  return apiRequestWrapper(`/issuers/issues/${id}`, {}, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token.value}`,
    },
    body: {
      heroSection: {
        image,
      },
    },
  })
}
